import React from 'react';
import { HardHatIcon, ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-concrete-950 pt-1.5" data-id="element-98" data-mp="eibqho5m10ai">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/428c5c9a-47ca-4b1e-a26c-6899314ca744.jpg" alt="Maestro de obra mexicano con casco y chaleco parado en una construcción al atardecer" className="absolute inset-0 h-full w-full object-cover object-[60%_top] opacity-30 sm:opacity-40 lg:opacity-60 lg:object-[70%_center]" data-id="element-99" data-mp="9luxafjjzvqk" />
      <div className="absolute inset-0 bg-concrete-950/85 lg:bg-gradient-to-r lg:from-concrete-950 lg:via-concrete-950/90 lg:to-concrete-950/10" data-id="element-100" data-mp="sarv2te5t6dj" />

      <div className="relative mx-auto max-w-7xl px-5 pb-12 pt-10 sm:px-8 sm:pb-16 sm:pt-14 lg:pb-24 lg:pt-20" data-id="element-101" data-mp="nbygexn4z9bs">
        <div className="max-w-3xl" data-id="element-102" data-mp="3czfme2gnud7m">
          <span className="inline-flex items-center gap-2 border-l-4 border-safety bg-concrete-900/80 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-safety sm:text-sm" data-id="element-103" data-mp="381xn73sg3cct">
            <HardHatIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="3o7bzdvq44lfk" />
            Edición México 🇲🇽
          </span>

          <h1 className="mt-5 font-display text-[2rem] uppercase leading-[0.95] text-concrete-50 sm:text-6xl lg:text-7xl" data-id="element-105" data-mp="39b4hx3639y3z">
            ¿Cansado de partirte el lomo para que{' '}
            <span className="text-safety" data-id="element-106" data-mp="30iazwxz9ckmf">tu jefe se quede con la mejor lana</span>?
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-concrete-200 sm:text-xl" data-id="element-107" data-mp="358hleoyh3p0g">
            Deja de ser "maistro" o albañil y conviértete en{' '}
            <strong className="font-bold text-concrete-50" data-id="element-108" data-mp="2qloeo830rrjv">CONTRATISTA ELITE</strong>.
            Aprende a ganar como los grandes: trabajando con inteligencia, no solo
            con las manos.
          </p>

          <div className="mt-8 flex flex-col items-stretch gap-4 sm:flex-row sm:items-center" data-id="element-109" data-mp="2hl9rt4aeq4e9">
            <CtaButton size="lg" className="w-full text-center sm:w-auto" data-id="element-110" data-mp="2lmv0edfwrwin">
              Quiero ser Contratista Elite
              <ArrowRightIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-111" data-mp="nbbc4wdi0748" />
            </CtaButton>
            <p className="text-center text-xs font-semibold uppercase tracking-wide text-concrete-400 sm:text-left sm:text-sm" data-id="element-112" data-mp="ic88ngd628yd">
              Solo $25 USD · $450 MXN aprox.
              <br className="hidden sm:block" data-id="element-113" data-mp="db2cf8kas3k3" /> Descarga inmediata en tu celular
            </p>
          </div>

          <figure className="relative mt-8 max-w-xl sm:mt-10" data-id="element-114" data-mp="1ayjg9az6xa4o">
            <div className="border-2 border-concrete-700 bg-concrete-900 p-2 shadow-slab sm:p-3" data-id="element-115" data-mp="16342sk53hg8s">
              <img src="https://cdn.magicpatterns.com/uploads/vpTFZA5be2uLotBeoSdJmC/constructor_1.png" alt="Megapack Constructor Elite 360: 6 tomos, 3 módulos extras y 5 bonos exclusivos" className="w-full" data-id="element-116" data-mp="111ewfhsthqr1" />
            </div>
            <figcaption className="mt-3 text-xs uppercase tracking-wide text-concrete-400 sm:text-sm" data-id="element-117" data-mp="3hqam6y4cdrp9">
              Todo esto te llega en digital, hoy mismo.
            </figcaption>
          </figure>
        </div>
      </div>

      <div className="hazard-bar h-3 w-full" aria-hidden="true" data-id="element-118" data-mp="21b631vfd8wll" />
    </header>;
}